module.exports = __webpack_public_path__ + "static/img/standard.a90f643f.png";